/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React from 'react';
import useFormApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-form-api';
import { useDdf } from '../../context/ddf-context';

const GridRowFlex = ({ fields, name, setEditMode, isChecked, index, fractionGrid }) => {
  const { handlers } = useDdf();
  const editedFields = fields.map((field) => ({ ...field, name: `${name}.${field.name}` }));
  const { renderForm } = useFormApi();

  const manageHandler = () => {
    if (handlers.onManage) {
      handlers.onManage({ name, index });
    } else {
      setEditMode(name);
    }
  };

  return (
    <div
      className="odd:bg-gray-15"
      style={{
        display: 'grid',
        gridTemplateColumns: fractionGrid
      }}
    >
      {editedFields.map((field) => {
        if (field.component === 'checkbox-grid') {
          field.isChecked = isChecked;
          return renderForm([{ ...field, component: 'checkbox-grid' }]);
        } else {
          return renderForm([{ ...field, component: 'grid-cell' }]);
        }
      })}
      <div className="w-20 px-2 py-2 text-primary-500 leading-8">
        <button className="hover:underline" type="button" onClick={manageHandler}>
          Manage
        </button>
      </div>
    </div>
  );
};

export default GridRowFlex;
